import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  adminModules,
  canAccessAdminRoute,
  getAdminRoute,
} from "../../Config/routes";
import { showSidebar } from "../../redux/actions/sidebarActions";
import CollapseGroup from "./CollapseGroup";

export default function ModuleNavigation({ moduleId }) {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const module = adminModules[moduleId];
  if (!module) return null;

  const route = getAdminRoute(module.route);
  const canOpenModule = canAccessAdminRoute(route);
  const children = (module.children || [])
    .map(getAdminRoute)
    .filter(canAccessAdminRoute);
  if (!route || (!canOpenModule && !children.length)) return null;

  const navigate = (path) => {
    history.push(path);
    dispatch(showSidebar(false));
  };
  const Icon = route.icon;
  const renderItem = (item) => {
    const ItemIcon = item.sidebarIcon || item.icon;
    const title = t(item.sidebarTitle || item.title);
    return (
      <ListItem button key={item.path} onClick={() => navigate(item.path)}>
        <ListItemIcon><ItemIcon /></ListItemIcon>
        <ListItemText
          primary={title}
          primaryTypographyProps={{
            style: { fontSize: title.length > 15 ? 13 : undefined },
          }}
        />
      </ListItem>
    );
  };

  if (module.plain) return renderItem(route);

  return (
    <CollapseGroup
      mainItemAction={
        canOpenModule && module.link !== false
          ? () => navigate(route.path)
          : undefined
      }
      mainItemIcon={<Icon />}
      header={t(route.title)}
    >
      {children.length ? children.map(renderItem) : undefined}
    </CollapseGroup>
  );
}
